<template>
  <div class="enterprise-card">
    <!-- 第一栏：左侧图标区块 -->
    <div class="head-icon">
      <div class="icon-box">
        <img src="@/assets/vipImg/icon4.png" class="icon-img" />
      </div>
    </div>

    <!-- 第二栏：企业版标题 + 三列权益 -->
    <div class="content-block">
      <div class="content-head">
        <h3 class="ent-title">{{ enterpriseData.title }}</h3>
        <p class="ent-sub">{{ enterpriseData.subTitle }}</p>
      </div>
      <div class="feature-row">
        <div
          class="feature-col"
          v-for="(list, idx) in [
            enterpriseData.leftFeature,
            enterpriseData.midFeature,
            enterpriseData.rightFeature,
          ]"
          :key="idx"
        >
          <div v-for="item in list" :key="item" class="feature-item">
            <CheckOutlined />
            <span>{{ item }}</span>
          </div>
        </div>
      </div>
    </div>

    <!-- 第三栏：右侧定制报价 -->
    <div class="action-block">
      <div class="custom-text">{{ enterpriseData.customTip }}</div>
      <div class="custom-texts">{{ enterpriseData.customText }}</div>
      <a-button
        size="large"
        class="ent-btn"
        :style="{
          background: enterpriseData.btnColor,
          borderColor: enterpriseData.btnColor,
        }"
        @click="goContact"
      >
        {{ enterpriseData.btnText }}
      </a-button>
      <span class="tip-link" @click="goContact">预约产品演示 →</span>
    </div>
  </div>
</template>

<script setup>
import { CheckOutlined } from "@ant-design/icons-vue";
import { useRouter } from "vue-router";
const router = useRouter();
defineProps(["enterpriseData"]);
const goContact = () => {
  // 新标签页打开 /Contact
  const url = router.resolve("/Contact").href;
  window.open(url, "_blank");
};
</script>

<style scoped lang="less">
.enterprise-card {
  background: linear-gradient(180deg, #fffcf8 0%, #ffffff 55%, #ffffff 100%);
  box-shadow: 0px 12px 30px 0px rgba(225, 148, 72, 0.08);
  border-radius: 22px;
  border: 1px solid #f2cfad;
  padding: 28px 24px;
  display: grid;
  grid-template-columns: 80px 1fr 280px;
  gap: 24px;
  align-items: flex-start;

  /* 左侧图标区块 */
  .head-icon {
    .icon-box {
      width: 74px;
      height: 74px;
      display: flex;
      align-items: center;
      justify-content: center;
      background: #fff0e0;
      border-radius: 16px;
      .icon-img {
        width: 63px;
        height: 63px;
      }
    }
  }

  /* 中间主体内容 带右侧分割线 */
  .content-block {
    padding-right: 24px;
    border-right: 1px solid #f2cfad;
    .content-head {
      margin-bottom: 24px;
      .ent-title {
        font-family: Inter;
        font-weight: 600;
        font-size: 26px;
        color: #17294a;
        line-height: 44px;
        margin: 0;
      }
      .ent-sub {
        margin: 0;
        font-family: Inter;
        font-weight: 400;
        font-size: 16px;
        color: #6c7a90;
        line-height: 32px;
      }
    }
    /* 内部三列权益等分 */
    .feature-row {
      display: grid;
      grid-template-columns: repeat(3, 1fr);
      gap: 12px;
      .feature-col {
        .feature-item {
          display: flex;
          align-items: center;
          gap: 10px;
          font-family: PingFangSC;
          font-weight: 400;
          font-size: 16px;
          color: #334662;
          line-height: 36px;
          margin-left: 0;
          /* 橙色圆形背景勾选，和截图一致 */
          :deep(.anticon) {
            width: 20px;
            height: 20px;
            display: inline-flex;
            align-items: center;
            justify-content: center;
            color: #fff;
            background: #f08b2c;
            border-radius: 50%;
            font-size: 12px;
          }
        }
      }
    }
  }

  /* 右侧定制报价区域 */
  .action-block {
    // text-align: center;
    padding-left: 10px;
    .custom-text {
      font-size: 26px;
      font-weight: 600;
      color: #17294a;
      margin-bottom: 16px;
      line-height: 36px;
    }
    .custom-texts {
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      font-size: 14px;
      color: #7a8798;
    }
    .ent-btn {
      width: 212px;
      height: 40px;
      margin: 32px 0;
      background: #f58c26;
      border-radius: 12px 12px 12px 12px;
      border: 1px solid #f29c48;
      font-family: Inter, Inter;
      font-weight: normal;
      font-size: 14px;
      color: #ffffff;
    }
    .tip-link {
      display: block;
      font-family: AppleSystemUIFont;
      font-size: 13px;
      color: #4380ff;
      line-height: 16px;
      margin-top: 10px;
      cursor: pointer;
      &:hover {
        opacity: 0.75;
      }
    }
  }
}
</style>
